var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProfileActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#fff",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Userprofile_activ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.82,17.39l3.9-4.27a1,1,0,0,1,1.41-.07,1,1,0,0,1,.08,1.39L14.11,20,9.88,17a1,1,0,0,1-.23-1.37,1,1,0,0,1,1.4-.23ZM2.47,18.7a1,1,0,0,1-1,1,1,1,0,0,1-1-1,7.93,7.93,0,0,1,8-7.87,8.07,8.07,0,0,1,4.09,1.11,1,1,0,0,1,.35,1.35,1,1,0,0,1-1.37.34,6.07,6.07,0,0,0-3.07-.83A6,6,0,0,0,2.47,18.7Zm9-13.77a3,3,0,0,0-6,0,3,3,0,0,0,6,0Zm2,0a5,5,0,0,1-10,0A5,5,0,0,1,8.47,0,5,5,0,0,1,13.47,4.93Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfileActive);
export default __webpack_public_path__ + "static/media/icon-profile-active.eca26a7f6cc31f612a318f14a4f50969.svg";
export { ForwardRef as ReactComponent };